import { api } from '../api/client';
import type { SelectId } from '../components/MultiSelect';

/** Minimal option shape the MultiSelect widget consumes. */
export interface TargetOption {
  _id: SelectId;
  name: string;
}

/**
 * Maps a relation `target` (from meta.relations) to a fetcher returning the
 * list of selectable options. Each fetcher normalizes its API result to
 * `{ _id, name }`. Add a new target here when wiring up a new m2m relation.
 *
 * All referenced api methods verified present in src/api/client.ts.
 */
const targetFetchers: Record<string, () => Promise<TargetOption[]>> = {
  group: () => api.groups.list().then((r) => normalize(r.data)),
  activity: () => api.activities.list().then((r) => normalize(r.data)),
  user: () => api.users.list().then((r) => normalize(r.data)),
  course: () => api.courses.list().then((r) => normalize(r.data)),
  membership: () => api.memberships.list().then((r) => normalize(r.data)),
};

function normalize(data: unknown): TargetOption[] {
  if (!Array.isArray(data)) return [];
  return data.map((item: any) => ({
    _id: item._id ?? item.id,
    name: item.name ?? String(item._id ?? item.id),
  }));
}

/** Returns the fetcher for a target, or undefined if the target is unregistered. */
export function getTargetFetcher(target: string): (() => Promise<TargetOption[]>) | undefined {
  return targetFetchers[target];
}
